import { c, eyebrowStyle, h1Style, ledeStyle, pageStyle } from '../tokens';

/**
 * Docs and Settings exist in the mock's sidebar but have no designed screen.
 * Rendering an honest empty state beats a dead nav item or a fake page.
 */
export function Placeholder({ screen }: { screen: 'docs' | 'settings' }) {
  const copy = {
    docs: {
      eyebrow: 'Docs',
      title: 'Platform documentation',
      lede: 'The pipeline contract, the app shapes, and the runbook live in the citizen-developer-core-infra repo. A rendered view lands here.',
    },
    settings: {
      eyebrow: 'Settings',
      title: 'Settings',
      lede: 'Notification preferences and per-app secret management land here. Secrets are created by the infra PR when you enable them during app creation.',
    },
  }[screen];

  return (
    <div style={{ ...pageStyle, gap: 28 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <span style={eyebrowStyle}>{copy.eyebrow}</span>
        <h1 style={h1Style}>{copy.title}</h1>
        <p style={ledeStyle}>{copy.lede}</p>
      </div>
      <div
        style={{
          border: `1px dashed ${c.border}`,
          borderRadius: 16,
          padding: 32,
          color: c.textFaint,
          fontSize: 13.5,
          background: c.subtle,
        }}
      >
        Not built yet.
      </div>
    </div>
  );
}
